module.exports = __webpack_public_path__ + "static/img/ers.fc56788.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ers.png
// module id = URDl
// module chunks = 0